<template>
  <div class="settle-manager" @keyup.enter="enterSearch">
    <el-form ref="form" :model="form" inline class="table-search-bar" label-width="100px">
      <el-form-item label="盘点时间" prop="operateDate">
        <el-date-picker v-model="form.operateDate" type="month" placeholder="请选择年月" format="yyyy-MM" value-format="yyyy-MM" :picker-options="{ disabledDate (time) { return time.getTime() > Date.now() } }" style="width: 100%" />
      </el-form-item>
      <el-form-item label="库区名称" prop="oilDepotCode">
        <el-select v-model="form.oilDepotCode">
          <el-option v-for="item in oilDepotOptions" :key="item.code" :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="油罐编码" prop="oilTankCode">
        <el-select v-model="form.oilTankCode" clearable>
          <el-option v-for="item in formOilTankOptions" :key="item.oilTankCode" :label="item.oilTankCode"
            :value="item.oilTankCode">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        <el-button type="primary" @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" style="width: 100%" tooltip-effect="light">
      <el-table-column prop="reservoirAreaName" label="油库" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="oilTankCode" label="罐号" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="systemOpeningQuantity" label="期初理论库存" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="realityOpeningQuantity" label="期初实存" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="systemInQuantity" label="理论入库量" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="systemOutQuantity" label="理论出库量" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="systemEndingQuantity" label="理论库存" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="realityEndingQuantityTotal" label="期末累计实存" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="practicalQuantity" label="实际库存" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="realityProfit" label="月度盘盈" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="realityLoss" label="月度盘亏" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="realityWastage" label="合理损耗" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="realityWastageDiff" label="损耗差异" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="realityWastageRatio" label="损耗率" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="additiveUse" label="助剂使用" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="additiveQuantity" label="助剂库存" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="memo" label="备注" show-overflow-tooltip>
      </el-table-column>
    </el-table>
    <el-pagination :page-sizes="[10, 20, 50, 100]" :page-size="listState.pageSize"
      layout="total, sizes, prev, pager, next, jumper" :total="listState.total" :current-page="listState.pageNo"
      background @current-change="handleCurrentChange" @size-change="handleSizeChange">
    </el-pagination>
    <el-row class="export-row" type="flex" justify="end">
        <el-button type="primary" @click="handleExportCSV">导出为CSV文件</el-button>
    </el-row>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import HttpUtil from '@/common/HttpUtil'
export default {
  name: 'inventoryXnyLossReport',
  data () {
    // 获取当前年月，格式为yyyy-MM
    // const now = new Date()
    // const year = now.getFullYear()
    // const month = String(now.getMonth() + 1).padStart(2, '0')
    // const currentMonth = `${year}-${month}`
    return {
      form: {
        operateDate: null
      },
      tableData: [],
      listState: {
        pageSize: 10,
        pageNo: 1
      },
      formOilTankOptions: [],
      reservoirAreaCode: 'XNYYPK',
      oilDepotOptions: [
        { code: 'PJPSK', name: '盘锦盘山油库' },
        { code: 'JHK', name: '天津静海油库' },
        { code: 'CMK', name: '山西昌茂油库' }
      ]
    }
  },

  methods: {
    ...mapActions(['getDicOilTankList']),
    enterSearch (e) {
      // 回车搜索
      if (e.target.form && e.target.nodeName === 'INPUT') {
        this.handleSearch()
      }
    },
    // 处理HTTP请求错误
    handleRequestError (error) {
      console.error('请求错误:', error)
      this.$message.error('操作失败，请重试')
    },
    // 通用的分页查询函数
    fetchData (params = {}) {
      const searchParams = {
        endTime: this.form.operateDate,
        reservoirAreaCode: this.form.oilDepotCode,
        oilTankCode: this.form.oilTankCode,
        status: 0,
        ...this.listState,
        ...params
      }
      HttpUtil.post('manage/lifonda/inventoryXnyLoss/report', searchParams)
        .then((res) => {
          if (res && res.data) {
            this.tableData = res.data.list || []
            this.listState.total = res.data.total || 0
            this.listState.pageNo = res.data.pageNum || 1
            this.listState.pageSize = res.data.pageSize || 10
          }
        })
        .catch((error) => {
          console.error('请求错误:', error)
          this.$message.error('操作失败，请重试')
        })
    },
    // 搜索
    handleSearch () {
      this.listState.pageNo = 1 // 重置页码
      this.fetchData()
    },
    // 分页条数变更
    handleSizeChange (val) {
      this.fetchData({ pageSize: val, pageNo: 1 })
    },
    // 分页跳转
    handleCurrentChange (val) {
      this.fetchData({ pageNo: val })
    },
    // 查询表单，表格重置
    handleReset () {
      this.$refs.form.resetFields()
      this.handleSearch()
    },
    // 导出
    handleExportCSV () {
      this.$confirm('是否确认导出', '导出', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const searchParams = {
          queryTime: this.form.operateDate,
          status: 0,
          ...this.listState
        }
        const blobParam = {
          responseType: 'blob'
        }
        HttpUtil.post('manage/lifonda/inventoryXnyLoss/export', searchParams, blobParam).then((res) => {
          function createDownloadFile () {
            let blob = new Blob([res])
            let link = document.createElement('a')
            link.download = '实存及损耗报表.xls'
            link.style.display = 'none'
            link.target = '_Blank'
            link.href = window.URL.createObjectURL(blob)
            document.body.appendChild(link)
            link.click()
            window.URL.revokeObjectURL(link.href)
          }
          createDownloadFile()
          this.$message.success('导出成功')
        })
      })
    },
    // 初始化油罐数据
    initOilTankData (reservoirAreaCode = this.reservoirAreaCode) {
      this.getDicOilTankList({ reservoirAreaCode })
        .then((res) => {
          if (res && Array.isArray(res)) {
            const temp = res.map((item) => ({
              oilTankCode: item.oilTankCode,
              oilTankName: item.oilTankName
            }))
            this.formOilTankOptions = temp
          }
        })
        .catch(this.handleRequestError)
    }
  },

  mounted () {
    this.handleSearch()
    this.initOilTankData()
  },

  watch: {
    $route () {
      this.handleSearch()
      this.initOilTankData()
    }
  }
}
</script>
<style scoped>
.upload-btn {
  display: inline-block;
  margin: 0 10px;
}

.export-row {
  margin-top: 10px;
}
</style>
